<template>
	<div class="recharge-container ">
		<header>
			<div style="display: block;">
				<div class="cu-custom" style="height: 45px;">
					<div class="cu-bar fixed bg-gradual-black" style=" height: 45px; padding-top: 0px;">
						<div class="content text-gold" style="top: 0px;">
							<div>BTC {{$t('cunru')}}</div>
						</div>
						<div class="action" @click="changego">
							<text class="cuIcon-back" style="width: 50px;">
								<span></span>
							</text>
						</div>
					</div>
				</div>
			</div>
		</header>
		<div class="cu-card dynamic">
			<div class="cu-item bg-gradual-black" style="border-radius: 15px;">
				<div class="text-content text-xs margin-top"><uni-text
						class=" text-gold text-xs"><span>{{$t('erwei')}}</span></uni-text>
				</div>
				<div class="" style="margin:20px;"><uni-image class="qrcode-img">
						<div
							style="background-image: url(&quot;&quot;); background-position: 0% 0%; background-size: 100% 100%; background-repeat: no-repeat;">
						</div> <img :src="'https://my.tv.sohu.com/user/a/wvideo/getQRCode.do?text=' + btc"
							draggable="false">
					</uni-image></div>
			</div>
			<div class="cu-item grid">
				<div class="cu-form-group">
					<div class="title text-gold">{{$t('jine')}}</div><uni-input class="border shadow">
						<div class="uni-input-wrapper">
							<div class="wqeww" v-show="!hasValue">{{$t('shuruu')}}</div><input maxlength="140"
								step="0.000000000000000001" enterkeyhint="done" autocomplete="off" type="number"
								class="weqqa" v-model="amount" @input="handleInput">
						</div>
					</uni-input>
				</div>
			</div>
			<div class="cu-item grid">
				<div class="cu-form-group">
					<div class="title text-gold">{{$t('pipei')}}</div><uni-input class="border shadow">
						<div class="uni-input-wrapper">
							<div class="uni-input-placeholder input-placeholder" style="display: none;">{{$t('shuruu')}}
							</div><input disabled="disabled" maxlength="140" step="" enterkeyhint="done" v-model="btc"
								autocomplete="off" type="" class="" ref="addressInput">
						</div>
					</uni-input><uni-button class="cu-btn bg-gradual-black shadow sm text-gold"
						@click="copyAddress">{{$t('fuzz')}}</uni-button>
				</div>
			</div>
			<div class="padding flex flex-direction">
				<input type="file" ref="fileInput" style="display:none" accept="image/*" @change="handleFileChange">
				<uni-button class="cuIcon-upload cu-btn bg-gradual-green lg"
					@click="triggerFileInput">{{$t('shangpin')}}</uni-button>
				<div v-if="imageUrl" class="preview-container">
					<img :src="imageUrl" alt="预览图片" class="preview-image" style="max-width: 20%;">
				</div>

			</div>
			<div class="padding flex flex-direction"><uni-button class="cuIcon-charge cu-btn bg-gradual-blue lg"
					@click="submitForm">{{$t('tjiao')}}</uni-button>
			</div>
		</div>
	</div>
</template>
<script>
	// import AlertPop from "@/components/alert/AlertPop.vue";
	import userApi from "@/api/user";
	export default {
		name: "RechargePage",
		// components: {
		// 	AlertPop,
		// },
		data() {
			return {
				// amount: null,
				walletAddress: "0x71C7656EC7ab88b098defB751B7401B5f6d8976F",
				receiptFile: null,
				receiptPreview: null,
				inputValue: '',
				hasValue: false,
				money: this.$t('jiazaizhong'),
				usdttr: null,
				usdter: null,
				btc: null,
				xingming: null,
				alertType: null,
				TipsTxt: this.$t('Tips.youke'),
				PopAlert: false,
				selectedFile: null,
				imageUrl: '',
				uploadProgress: 0,
				amount: '',
				image: null,
				coin_name: 'BTC',
			};
		},
		computed: {
			group_id() {
				return this.$store.state.group_id;
			},
		},
		methods: {
			triggerFileInput() {
				this.$refs.fileInput.click();
			},
			handleFileChange(e) {
				const file = e.target.files[0];
				if (!file) return;

				if (!file.type.match('image.*')) {
					this.$toast.error('请选择有效的图片文件');
					return;
				}

				this.selectedFile = file;
				this.generatePreview(file);
				this.uploadFile(file);
			},
			uploadFile(file) {


				// const formData = new FormData();
				// formData.append('file', file);


				userApi.uploads(file).then(() => {

					this.$toast.clear();
				}).catch((err) => {
					this.$toast.clear();
					this.$toast.fail(err.msg);
				});
			},
			generatePreview(file) {
				const reader = new FileReader();
				reader.onload = (e) => {
					this.imageUrl = e.target.result;
				};
				reader.readAsDataURL(file);
			},

			copyAddress() {
				const input = this.$refs.addressInput;
				input.select();
				document.execCommand('copy');

				// 现代浏览器推荐写法
				if (navigator.clipboard) {
					navigator.clipboard.writeText(this.btc)
						.then(() => {
							this.$toast.success(this.$t('fuz'));
						})
						.catch(err => {
							console.error(this.$t('fwwq'), err);
							this.$toast.fail(this.$t('fwwq'));
						});
				} else {
					// 兼容旧浏览器
					try {
						document.execCommand('copy');
						this.$toast.success(this.$t('fuz'));
					} catch (err) {
						console.error(this.$t('fwwq'), err);
						this.$toast.fail(this.$t('fwwq'));
					}
				}
			},
			changego() {
				this.$router.go(-1);
			},
			handleInput() {
				this.hasValue = this.amount !== ''
			},
			submitForm() {
				if (!this.imageUrl) {
					this.$toast.fail("请先上传凭证图片");
					return; // 终止函数执行
				}
				userApi.uploadVoucher(this.amount, this.image, this.coin_name)
					.then((data) => {
						console.log(data.data, "上传成功");
						// this.$toast.success("凭证上传成功");
						this.$router.push({
							path: "/personal",
						});
					})
					.catch((err) => {
						this.$toast.clear();
						this.$toast.fail(err.msg || "上传失败，请重试");
					});
			},
			info() {
				this.$toast.loading({
					message: this.$t('jiazaizhong'),
					forbidClick: true,
					duration: 0,
				});
				userApi
					.recharge()
					.then((data) => {
						// console.log(data, 3221);
						this.money = data.data.money;
						this.usdttr = data.data.usdttr;
						this.usdter = data.data.usdter;
						this.btc = data.data.btc;
						this.xingming = data.data.bankxm;
						this.$toast.clear();
						this.PopAlert = true;
					})
					.catch((err) => {
						this.$toast.clear();
						this.$toast.fail(err.msg);
					});
			},
		},
		mounted() {
			console.log(this.group_id);
		},
		created() {
			this.info();
			if (this.group_id != 1) {
				this.alertType = 1;
			}
		},
	};
</script>

<style scoped>
	.cu-custom .cu-bar .content {
		width: calc(100% - 212px);
	}

	.wqeww {
		position: absolute;
		top: auto !important;
		font-weight: bolder;
		color: grey;
		overflow: hidden;
		text-overflow: clip;
		white-space: pre;
		word-break: keep-all;
		pointer-events: none;
		line-height: inherit;
	}

	.weqqa {
		position: relative;
		display: block;
		height: 100%;
		background: none;
		color: inherit;
		opacity: 1;
		font: inherit;
		line-height: inherit;
		letter-spacing: inherit;
		/* 		text-align: inherit; */
		text-indent: inherit;
		text-transform: inherit;
		text-shadow: inherit;
	}

	.cuIcon-upload:before {
		content: "\e75d";
	}

	.recharge-container {
		font-family: 'Inter', 'PingFang SC', 'Microsoft YaHei', sans-serif;
	}
</style>